<script lang="ts">
  import type { Theme } from "website_script/types/theme"
  import closeIcon from "../Icons/Close.svg?raw"
  import Icon from "../components/Icon.svelte"
  import { hexToRgba } from "./../../lib/helpers"
  import { getContext } from "svelte"
  import { createEventDispatcher } from "svelte"

  const { neutralTextColor } = getContext<Theme>("theme")

  const dispatch = createEventDispatcher()
</script>

<div
  class="card"
  style="{`--shadow-color: ${hexToRgba(neutralTextColor, 0.25)}`};"
>
  <div class="card-close" on:click={() => dispatch("close")}>
    <Icon
      svgProps={{
        data: closeIcon,
        alt: "close card",
        color: neutralTextColor,
      }}
      size="40px"
    />
  </div>
  <slot />
</div>

<style>
  .card {
    border: 1px solid #ffffff;
    box-sizing: border-box;
    box-shadow: -1px 4px 6px 1px var(--shadow-color);
    background-color: #ffffff;
    border-radius: 8px;
    padding: 15px;
    position: relative;
  }

  .card-close {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 2;
  }

  @media screen and (max-width: 760px) {
    .card {
      padding: 7px;
    }
  }
</style>
